// extracted by mini-css-extract-plugin
module.exports = {"navArrowsContainer":"AuctionNavigation_navArrowsContainer__3hTLA","leftArrow":"AuctionNavigation_leftArrow__1NOSB","rightArrow":"AuctionNavigation_rightArrow__33rdI"};